import { createReducer, on } from '@ngrx/store';
import { initialState } from './state';
import { PROCUREMENT } from './actions';
import { ProjectDTO, IS_NULL_OR_UNDEFINED } from 'cargo-chief-commons';
import { C4ListResponse } from '@domain/interface/c4-list-response';

export const reducers = createReducer(
	initialState,
	on(PROCUREMENT.PROJECTS_LIST.GET, (state) => ({ ...state, loading: true })),
	on(PROCUREMENT.PROJECTS_LIST.SUCCESS, (state, action: C4ListResponse<ProjectDTO>) => ({
		...state,
		loading: false,
		projects: action.data,
		total: action.totalElements,
	})),
	on(PROCUREMENT.PROJECTS_LIST.FAILURE, (state, action) => ({
		...state,
		loading: false,
		error: action.payload.message,
	})),

	on(PROCUREMENT.USERS_LIST.SET, (state, action) => ({
		...state,
		usersList: action.usersList,
	})),

	on(PROCUREMENT.SORT.SET, (state, action) => ({
		...state,
		sort: action.sort,
	})),
	on(PROCUREMENT.FILTERS.SET, (state, action) => ({
		...state,
		filters: action.filters,
	})),

	on(PROCUREMENT.TABS.SET, (state, action) => ({
		...state,
		allTabs: action.allTabs,
	})),

	// update state fields
	on(PROCUREMENT.ACTIVE_TAB.SET, (state, action) => ({
		...state,
		activeTab: action.activeTab,
	})),
	on(PROCUREMENT.USERS_SORT_AND_FILTERS.SET, (state, action) => ({
		...state,
		userSortAndFilters: action.userSortAndFilters,
	})),

	// update project fields
	on(PROCUREMENT.EDIT_PROJECT.UPDATE_DUE_DATE, (state, action) => ({
		...state,
		projects: state.projects.map((project) => {
			let projectDTO = Object.assign({}, project);
			if (action.projectIds.indexOf(project.id) !== -1) {
				projectDTO.dueDate = action.dueDate;
			}
			return projectDTO;
		}),
	})),
	on(PROCUREMENT.EDIT_PROJECT.UPDATE_CUSTOMER, (state, action) => ({
		...state,
		projects: state.projects.map((project) => {
			let projectDTO = Object.assign({}, project);
			if (action.projectIds.indexOf(project.id) !== -1) {
				projectDTO.customerDTO = action.customerDTO;
			}
			return projectDTO;
		}),
	})),
	on(PROCUREMENT.EDIT_PROJECT.UPDATE_ASSIGNEE, (state, action) => ({
		...state,
		projects: state.projects.map((project) => {
			let projectDTO = Object.assign({}, project);
			if (action.projectIds.indexOf(project.id) !== -1) {
				projectDTO.assigneeId = action.assigneeId;
			}
			return projectDTO;
		}),
	})),
	on(PROCUREMENT.EDIT_PROJECT.UPDATE_OUT_OF_NETWORK, (state, action) => ({
		...state,
		projects: state.projects.map((project) => {
			let projectDTO = Object.assign({}, project);
			if (action.projectIds.indexOf(project.id) !== -1) {
				projectDTO.sendToOutOfNetworkCarriers = action.sendToOutOfNetworkCarriers;
			}
			return projectDTO;
		}),
	})),
	on(PROCUREMENT.EDIT_PROJECT.UPDATE_SUCCESS, (state, { updatedProjects }) => ({
		...state,
		projects: state.projects.map((project) => updatedProjects[project.id] ?? project),
	})),


);
